import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-holiday',
  templateUrl: './add-holiday.component.html'
})
export class AddHolidayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/add-holiday/add-holiday.component.ts